<mat-card flex="100">
  <mat-card-title>
    {{ airCarrierAbbreviation }} Transmission Run Batch Items
    <button mat-raised-button (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div
      fxLayout="row wrap"
      fxLayoutGap="10px"
      fxLayoutAlign="start start"
      [formGroup]="transmissionRunBatchItemSummaryParameters"
    >
      <mat-form-field>
        <input matInput formControlName="searchTerm" placeholder="Search" />
        <button
          mat-button
          *ngIf="transmissionRunBatchItemSummaryParameters.controls.searchTerm.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="transmissionRunBatchItemSummaryParameters.controls.searchTerm.reset()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div class="checkbox-row">
        <mat-checkbox type="checkbox" formControlName="showErrorsOnly">
          Show Errors Only?
        </mat-checkbox>
      </div>
    </div>
    <div>
      <ng-template
        [flLoading]="loadingKey"
        [flLoadingUntil]="transmissionRunBatchItemSummaries$ | async"
        flLoadingStrategy="overlay"
        flLoadingColor="primary"
      >
        <table mat-table [dataSource]="transmissionRunBatchItemSummaries$" fxFlex="100">
          <ng-container matColumnDef="dateRun">
            <th mat-header-cell *matHeaderCellDef>Published Date</th>
            <td mat-cell *matCellDef="let summary">
              {{ (summary.publishedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="pilotName">
            <th mat-header-cell *matHeaderCellDef>Pilot Name</th>
            <td mat-cell *matCellDef="let summary">
              <a
                routerLink="/prd/{{ _route.snapshot.data.airCarrier.abbreviation }}/pilots/{{
                  summary.pilotId
                }}"
                class="link-text"
                target="_blank"
              >
                {{ summary.pilotFirstName }} {{ summary.pilotLastName }}
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="entityType">
            <th mat-header-cell *matHeaderCellDef>Entity Name</th>
            <td mat-cell *matCellDef="let summary">
              <a
                (click)="openEditDialog(summary.entityTypeName, summary.entityId, summary.pilotId)"
                class="link-text"
              >
                {{ humanizeEntityName(summary.entityTypeName) }}</a
              >
            </td>
          </ng-container>
          <ng-container matColumnDef="prdTrackingNumber">
            <th mat-header-cell *matHeaderCellDef>Prd Tracking Number</th>
            <td mat-cell *matCellDef="let summary">
              {{ summary.prdTrackingNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="isProcessed">
            <th mat-header-cell *matHeaderCellDef>Is Processed?</th>
            <td mat-cell *matCellDef="let summary">
              {{ summary.isProcessed | yesNo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="prdProcessedDate">
            <th mat-header-cell *matHeaderCellDef>PRD Processed Date</th>
            <td mat-cell *matCellDef="let summary">
              {{ (summary.prdProcessedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="hasError">
            <th mat-header-cell *matHeaderCellDef>Has Error</th>
            <td
              mat-cell
              *matCellDef="let summary"
              [ngClass]="{
                'prd-processing-error-text': summary.hasError
              }"
            >
              {{ summary.hasError | yesNo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="errorDescription">
            <th mat-header-cell *matHeaderCellDef>Error Description</th>
            <td mat-cell *matCellDef="let summary" class="prd-processing-error-text">
              {{ summary.errorDescription }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">No records found.</td>
          </tr>
        </table>
      </ng-template>
    </div>
    <div>
      <mat-paginator
        [pageSize]="pageSize$ | async"
        [pageIndex]="pageIndex$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [length]="total$ | async"
        (page)="onPage($event)"
      >
      </mat-paginator>
    </div>
    <button class="back-button" mat-raised-button routerLink="..">
      <mat-icon>arrow_back</mat-icon>Back
    </button>
  </mat-card-content>
</mat-card>
